<template>
  <div class="message-row message-header">
    <div class="subscription-col message-header-label">
      New Messages
    </div>
    <div class="subscription-col">
      <div v-if="emailSetting">
        <div class="imidiate-email">
          <input type="checkbox" v-model="emailSetting.immediate" @change="toggleMessageImmediate">
          <span>Immediate</span>
        </div>
        <!--<div class="daily-email">
          <input type="checkbox" v-model="emailSetting.daily" @change="toggleMessageDaily">
          <span>Daily Digest</span>
        </div>
        <div class="daily-email">
          <input type="checkbox" v-model="emailSetting.weekly" @change="toggleMessageWeekly">
          <span>Weekly Digest</span>
        </div>-->
      </div>
    </div>
    <div class="subscription-col">
      <input type="checkbox" v-model="notification" @change="notificationChanged">
      <span>Immediate</span>
    </div>
  </div>
</template>

<script>
import api from '../../../api/api';

export default {
  props: ['notificationProp', 'email'],
  data() {
    return {
      notification: false,
      emailSetting: null,
    }
  },
  created() {
    this.notification = this.notificationProp;
  },
  mounted() {
    this.emailSetting = this.email;
  },
  watch: {
    notificationProp(newValue) {
      this.notification = newValue;
    },
    email(newValue) {
      this.emailSetting = newValue;
    }
  },
  methods: {
    notificationChanged() {
      this.$emit('changenotification', this.notification);
    },
    toggleMessageImmediate() {
      api.post('/Communication/messages/', {
        Immediate: this.emailSetting.immediate,
        Id: this.emailSetting.id,
      });
    },
    toggleMessageDaily() {
      api.post('/Communication/messages/', {
        Daily: this.emailSetting.daily,
        Id: this.emailSetting.id,
      });
    },
    toggleMessageWeekly() {
      api.post('/Communication/messages/', {
        Weekly: this.emailSetting.weekly,
        Id: this.emailSetting.id,
      });
    },
  }
}
</script>

